export default {
	reviewDocuments: {
		account: '@:component.accounts.name',
		balance: 'Saldo',
		status_options: 'Statusoptionen',
		record_count_determined: 'Anzahl an Datensätzen wird ermittelt',
		document_review_protocol: 'Protokoll der Belegprüfung',
		automatic_reminder: 'Automatische Erinnerung',
		edit_documents: 'Dokumente bearbeiten',
		edit_reviewer: 'Prüfer bearbeiten',
		deactivate: 'Deaktivieren',
		activate: 'Aktivieren',
		create_protocol: 'Protokoll erstellen',
		review_requires_reviewer:
			'Es müssen erst Prüfer definiert werden, bevor die Belegprüfung aktiviert werden kann.',
		confirm_disable_review:
			'Möchten Sie die Belegprüfung wirklich deaktivieren?',
		confirm_finish_review_without_checks:
			'Sie haben noch keine Buchung geprüft, sind Sie sicher dass Sie die Belegprüfung abschliessen wollen?',
		confirm_approve_with_disputes:
			'Sie geben diese Belegprüfung frei, haben aber mindestens einer Buchung widersprochen. Sind Sie sicher?',
		confirm_reject_without_disputes:
			'Sie beanstanden diese Belegprüfung, haben aber keiner Buchung widersprochen. Sind Sie sicher?',
		confirm_review_action:
			'Sind Sie sich sicher, dass Sie die Belegprüfung {action} möchten?',
		reopen_notify_reviewers_info:
			'Wenn Sie die Belegprüfung erneut freigeben, können die Prüfer mit ausstehendem Status per E-Mail benachrichtigt werden.',
		notify_pending_reviewers:
			'Prüfer mit ausstehendem Status per E-Mail benachrichtigen',
		confirm_no_changes_after_completion:
			'Nach Abschluss der Belegprüfung sind keine Änderungen mehr möglich, möchten Sie fortfahren?',
		data_updated: 'Daten wurden aktualisiert',
		confirm_enable_review_message:
			'Möchten Sie die Belegprüfung wirklich aktivieren? An die definierten Prüfer wird eine Benachrichtigung verschickt. Nachträgliche Änderungen sind während der Prüfung nicht möglich.',
		review_completed: 'Belegprüfung abgeschlossen',
		invoice_review_completed:
			'Die Belegprüfung ist abgeschlossen, hier können Sie das Protokoll einsehen. Änderungen sind nicht mehr möglich.',
		invoice_review_completed_2:
			'Die Belegprüfung ist bereits abgeschlossen, Änderungen sind nicht mehr möglich.',
		invoice_protocol: 'Belegprüfung Protokoll',
		performedOn: 'Die Belegprüfung wurde am',
		filter: {
			incomplete: 'nicht abgeschlossen',
			all: 'alle',
		},
		protocol: {
			reviews: 'Prüfung',
			show_all: 'Andere Prüfung wählen ({count})',
			show_less: 'Auswahl schließen',
			search_label: 'Im Protokoll suchen',
			search_hint: 'Ab 2 Zeichen: Text, Konto, Datum, Betrag, PN, Kommentare',
			hits: 'Keine Treffer | {count} Treffer | {count} Treffer',
			hits_capped: '{count} Treffer · die ersten {max}',
			denied: 'beanstandet',
			toc: 'Inhalt',
			accounts: 'Konten · {selected}/{total}',
			all: 'Alle',
			only_denied: 'Nur beanstandete',
			reviewers: 'Prüfer',
			states: 'Anhang · Status der Buchungen',
			state_denied: 'Beanstandet',
			state_pending: 'Ohne Bewertung',
			state_approved: 'Bestätigt',
			options: 'Optionen',
			show_comments: 'Kommentare einblenden',
			show_appendix: 'Anhang: alle Buchungen',
			panel: 'Umfang, Inhalt und Suche',
			load_incomplete:
				'Nicht alle Daten wurden geladen. Das Protokoll kann so nicht erstellt werden.',
			reload: 'Erneut laden',
			size_warning:
				'Das Protokoll ist sehr groß ({size}) und überschreitet eventuell die zulässige Größe für die PDF-Erstellung. Möchten Sie den Anhang ausblenden?',
			size_hide_appendix: 'Ohne Anhang erstellen',
			size_keep: 'Mit Anhang erstellen',
		},
		cockpit: {
			phase: {
				draft: 'Entwurf · nicht aktiv',
				active: 'Aktiv · Prüfung läuft',
				completed: 'Abgeschlossen',
				completed_on: 'Abgeschlossen am {date}',
			},
			meta: {
				accounting_year: 'Buchungsjahr {year}',
				deadline: 'Frist {date}',
				no_deadline: 'ohne Frist',
			},
			links: {
				building: 'Zur Liegenschaft',
				overview: 'Zurück zur Übersicht der Belegprüfungen',
				person: 'Zur Person',
			},
			// Details-Popover am Info-i der Kopfzeile: Beschreibung und die
			// Meta-Angaben, die den Kopf sonst dauerhaft Zeilen kosten.
			info: {
				open: 'Details',
				building: 'Liegenschaft',
				accounting_year: 'Buchungsjahr',
				deadline: 'Frist',
			},
			manage: {
				menu: 'Verwalten',
				open_settings: 'Einstellungen',
				open_settings_hint: 'Einstellungen und Prüfer festlegen',
				comments_on: 'Kommentare aktivieren',
				comments_off: 'Kommentare deaktivieren',
				edit: 'Belegprüfung bearbeiten',
				edit_hint: 'Abgeschlossen — nur einsehbar',
				reviewers_hint: 'Nur im Entwurf änderbar',
				documents_hint: 'Abgeschlossen — nur einsehbar',
				// Verwaltungs-Modal: alles, was die Verwaltung an dieser Belegprüfung
				// einstellt, an einer Stelle statt verstreut über ein Menü.
				title: 'Belegprüfung verwalten',
				open: 'Belegprüfung verwalten',
				tab: {
					basics: 'Stammdaten & Status',
					reviewers: 'Prüfer',
					status: 'Status',
				},
				context: {
					building: 'Liegenschaft',
					accounting_year: 'Buchungsjahr',
				},
				settings: {
					title: 'Einstellungen',
					comments: 'Kommentare zu Buchungen',
					comments_hint:
						'Abgeschaltet können Prüfer weder Kommentare lesen noch schreiben. Bereits geschriebene Kommentare bleiben erhalten.',
				},
				status: {
					title: 'Status',
					draft_hint:
						'Die Belegprüfung ist noch ein Entwurf. Erst mit dem Aktivieren werden die Prüfer benachrichtigt und können prüfen; Prüfer lassen sich danach nicht mehr ändern.',
					active_hint:
						'Die Prüfung läuft. Deaktivieren hält sie an, Abschließen beendet sie und erzeugt das Protokoll.',
					completed_hint:
						'Die Belegprüfung ist abgeschlossen und schreibgeschützt. Wieder öffnen macht sie erneut bearbeitbar — aber nur, solange noch kein Protokoll erzeugt ist.',
					reopen: 'Wieder öffnen',
					deactivate: 'Deaktivieren',
				},
			},
			hint: {
				management:
					'Verwaltungs-Sicht: Prüfer, Aktivierung, Abschluss, Protokoll. Geprüft wird von den Personen mit Schreibzugriff.',
				write:
					'Schreibzugriff · Tasten: G geprüft, B beanstanden, Z zurücknehmen, N nächste offene, ←/→ blättern, / suchen.',
				write_touch: 'Schreibzugriff: prüfen und kommentieren.',
				own_progress: '{done} von {total} bearbeitet.',
				read: 'Lesezugriff: alles einsehen und kommentieren, nicht prüfen.',
				none: 'Sie sind für diese Belegprüfung nicht als Prüfer eingetragen.',
			},
			lock: {
				management:
					'Die Verwaltung prüft nicht selbst — das übernehmen die Personen mit Schreibzugriff.',
				draft:
					'Noch nicht aktiviert — Prüfen ist erst in der aktiven Phase möglich.',
				completed: 'Abgeschlossen — alles schreibgeschützt.',
				read: 'Lesezugriff: Sie können einsehen, aber nicht prüfen.',
				submitted:
					'Ihr Gesamtergebnis ist abgegeben — Buchungsprüfungen sind gesperrt.',
				login_as:
					'Sie sind als andere Person angemeldet — in dieser Sitzung sind keine Prüfungen möglich.',
				login_as_short: 'Im Modus „Anmelden als" nicht möglich',
			},
			// Protokoll erzeugt = Belegprüfung festgeschrieben (BPO-Meeting 23.09.).
			protocol_lock: {
				status:
					'Das Protokoll ist erzeugt — die Belegprüfung ist damit festgeschrieben. Sie lässt sich nicht mehr öffnen, Frist und Ergebnisse bleiben unverändert.',
				deadline:
					'Mit dem Protokoll ist die Belegprüfung festgeschrieben — die Frist lässt sich nicht mehr ändern.',
				withdraw:
					'Das Protokoll ist erzeugt — Ergebnisse lassen sich nicht mehr zurücknehmen.',
				confirm_create:
					'Mit dem Protokoll wird die Belegprüfung festgeschrieben: Danach lässt sie sich nicht mehr öffnen, die Frist nicht mehr ändern und kein Ergebnis mehr zurücknehmen. Möchten Sie das Protokoll jetzt erstellen?',
			},
			withdraw: {
				journal: 'Prüfung zurücknehmen',
				own_approved: 'Von Ihnen geprüft',
				own_denied: 'Von Ihnen beanstandet',
				overall: 'Gesamtergebnis zurücknehmen',
				overall_hint:
					'Ihr Gesamtergebnis wird wieder offen — Sie können danach weiter prüfen.',
				deadline_passed:
					'Die Prüffrist ist abgelaufen — wenden Sie sich an die Verwaltung.',
				blocked: 'Das Gesamtergebnis kann derzeit nicht zurückgenommen werden.',
				confirm_overall:
					'Möchten Sie Ihr Gesamtergebnis wirklich zurücknehmen? Es wird wieder offen, und eine bereits abgeschlossene Belegprüfung wird dadurch erneut geöffnet.',
				reviewer: 'Gesamtergebnis von {name} zurücknehmen',
				confirm_reviewer:
					'Möchten Sie das Gesamtergebnis von {name} wirklich zurücknehmen? Die Person kann danach wieder prüfen.',
			},
			progress: {
				title: 'Prüffortschritt',
				title_own: 'Ihr Prüffortschritt',
				consensus_line:
					'Konsens: {approved} geprüft · {denied} beanstandet · {open} offen',
				summary: '{done} von {total} Buchungen',
				approved: 'geprüft',
				denied: 'beanstandet',
				open: 'offen',
				hint: 'Konsens aller Prüfer: geprüft = alle haben zugestimmt · beanstandet = mindestens ein Widerspruch · offen = alles Übrige',
			},
			scale: {
				personal: 'Zählt Ihre eigenen Voten',
				consensus: 'Zählt den Konsens aller Prüfer',
			},
			reviewers: {
				title: 'Prüfer',
				summary: '{done} von {total} abgeschlossen',
				subline: '{count} Prüfer · {readers} lesend',
				subtitle: 'Fortschritt und Gesamtergebnis',
				subtitle_result: 'Gesamtergebnis',
				open_list: 'Prüferliste öffnen',
				progress_unknown: 'kein Fortschritt verfügbar',
				no_result: 'ohne Ergebnis',
				empty: 'Für diese Belegprüfung sind noch keine Prüfer eingetragen.',
			},
			finder: {
				title: 'Suche',
				open: 'Konten und Buchungen durchsuchen',
				placeholder:
					'Suchen in Konten und Buchungen — Nummer, Name, Buchungstext, Betrag, Datum, Kommentare, Belege …',
				hint: 'Gesucht wird auch in den Bezeichnungen und Dateinamen der Belege. Mehrere Wörter werden UND-verknüpft. Datum deutsch: 02.05.2026, 05.2026 für den Monat, 02.05. für den Tag in jedem Jahr.',
				accounts: 'Konten',
				journals: 'Buchungen',
				documents: 'Anlagen der Belegprüfung',
				empty: 'Nichts gefunden.',
				start:
					'Tippen Sie, um alle Konten und Buchungen dieser Belegprüfung zu durchsuchen.',
				more: '{count} weitere Treffer — Suche verfeinern',
			},
			accounts: {
				title: 'Konten',
				search: 'Konto suchen (Nr./Name) …',
				empty: 'Keine Konten für Suche und Filter.',
				footer: '{shown} von {total} Konten · {journals} Buchungen gesamt',
				progress_own: '{done} von {total} Buchungen von Ihnen bearbeitet',
				progress_consensus:
					'{done} von {total} Buchungen abschließend bewertet (alle Prüfer)',
				denied_hint:
					'{count} Buchungen beanstandet — Konsenswert über alle Prüfer, unabhängig von Ihrem eigenen Votum',
				filter: {
					all: 'Alle {count}',
					open: 'Offen {count}',
					denied: 'Beanst. {count}',
				},
			},
			journals: {
				title: 'Buchungen',
				search: 'Buchung suchen …',
				empty: 'Keine Buchungen für Suche und Filter.',
				no_account: 'Wählen Sie ein Konto aus.',
				footer: '{shown} von {total} angezeigt · Konto gesamt {accountTotal}',
				load_more: 'Weitere {count} laden',
				load_more_rest: 'Weitere {count} laden · {remaining} verbleiben',
				primanota: 'PN {value}',
				amount: {
					debit_short: 'S',
					credit_short: 'H',
					hint: '{kind}: {amount}',
				},
				sort: {
					label: 'Sortierung',
					menu: 'Buchungen sortieren',
					asc: 'aufsteigend',
					desc: 'absteigend',
					by: {
						booking_date: 'Buchungsdatum',
						debit: 'Soll',
						credit: 'Haben',
						booking_text: 'Buchungstext',
					},
				},
				filter: {
					all: 'Alle {count}',
					open: 'Offen {count}',
					denied: 'Beanst. {count}',
					approved: 'OK {count}',
				},
				state: {
					approved: 'Geprüft (alle Prüfer)',
					denied: 'Beanstandet',
					pending: 'Ausstehend',
				},
				bulk: {
					approve: 'Alle Buchungen dieses Kontos als geprüft markieren',
					deny: 'Alle Buchungen dieses Kontos beanstanden',
					// Sobald etwas angekreuzt ist, meint der Kopf-Knopf die Auswahl —
					// die Beschriftung muss das sagen, sonst verspricht sie das Konto.
					selected_approve:
						'{count} ausgewählte Buchungen als geprüft markieren',
					selected_deny: '{count} ausgewählte Buchungen beanstanden',
					confirm_approve:
						'Möchten Sie wirklich alle {count} Buchungen dieses Kontos als geprüft markieren?',
					confirm_deny:
						'Möchten Sie wirklich alle {count} Buchungen dieses Kontos beanstanden?',
				},
			},
			selection: {
				enter: 'Mehrere Buchungen auswählen',
				exit: 'Auswahl beenden',
				count: '{count} ausgewählt',
				approve: 'Auswahl als geprüft markieren',
				deny: 'Auswahl beanstanden',
				clear: 'Auswahl aufheben',
				confirm_approve:
					'Möchten Sie die {count} ausgewählten Buchungen als geprüft markieren?',
				confirm_deny:
					'Möchten Sie die {count} ausgewählten Buchungen beanstanden?',
				toast: {
					failed:
						'{failed} von {total} Buchungen konnten nicht gespeichert werden: {message}. Sie bleiben ausgewählt.',
				},
			},
			actions: {
				approve: 'Geprüft',
				deny: 'Beanstanden',
				overall_approve: 'Bestätigen',
				overall_deny: 'Beanstanden',
				overall_approve_hint:
					'Schließt Ihre Prüfung ab: Sie bestätigen die komplette Belegprüfung.',
				overall_deny_hint:
					'Schließt Ihre Prüfung ab: Sie beanstanden die komplette Belegprüfung und verweigern die Freigabe.',
				next_open: 'Nächste offene',
				previous_journal: 'Vorherige Buchung',
				next_journal: 'Nächste Buchung',
				back: 'Zurück',
				documents: 'Dokumente',
				protocol: 'Protokoll',
			},
			toast: {
				no_open_left:
					'Keine offenen Buchungen mehr für Sie — geben Sie oben Ihr Gesamtergebnis ab.',
				review_blocked:
					'Prüfen ist nicht möglich — Rolle, Phase oder Ihr bereits abgegebenes Gesamtergebnis sperren die Aktion.',
				reviewers_locked:
					'Prüfer können nur vor der Aktivierung geändert werden.',
				protocol_locked:
					'Das Protokoll steht erst nach dem Abschließen zur Verfügung.',
				review_failed: 'Die Prüfung konnte nicht gespeichert werden: {message}',
			},
			keyboard: {
				legend:
					'Tastatur: G geprüft · B beanstanden · Z zurücknehmen · N nächste offene · ←/→ blättern',
				// Ohne Prüfrecht wirken G und B nicht — dann bleibt die reine
				// Navigation übrig, die für jede Rolle funktioniert.
				legend_navigation: 'Tastatur: N nächste offene · ←/→ blättern',
				key_approve: 'Taste G',
				key_deny: 'Taste B',
				key_withdraw: 'Taste Z',
			},
			split: {
				handle:
					'Spaltenbreite ziehen · Doppelklick oder Pos1 stellt gleiche Breiten wieder her · ←/→ mit der Tastatur',
			},
			// Einführungstouren (useReviewCockpitTour.ts). HTML erlaubt, driver.js
			// rendert die Beschreibung als HTML.
			tour: {
				open: 'Einführung in die Belegprüfung starten',
				// Eintrag im ☰-Menü unter 1024 px (dort gibt es kein „?").
				menu_item: 'Einführung',
				// Schlüssel mit `_touch` und `levels`/`menu`: schmaler Strang unter
				// 1024 px — eine Ebene, Kopf-Symbole im ☰, keine Tastenkürzel.
				shared: {
					finder: {
						title: 'Suche',
						text: 'Mit <kbd>/</kbd> oder der Lupe öffnen Sie die Suche über alle Konten und Buchungen – nach Nummer, Name, Buchungstext, Betrag, Datum, Kommentar oder Beleg. Ein Treffer springt direkt zum Konto bzw. zur Buchung.',
					},
					finder_touch: {
						title: 'Suche',
						text: 'Die Suche erreichen Sie über ☰. Sie durchsucht alle Konten und Buchungen nach Nummer, Name, Buchungstext, Betrag, Datum, Kommentar oder Beleg. Ein Tipp auf einen Treffer führt direkt zum Konto bzw. zur Buchung.',
					},
					focus: {
						title: 'Fokus-Modus',
						text: 'Mit <kbd>F</kbd> blenden Sie alles andere aus und prüfen Buchung für Buchung mit großem Beleg. ←/→ blättert, auch über Kontogrenzen hinweg; die Leiste unten erinnert an die Tastenkürzel. Verlassen über das ✕ oben rechts oder <kbd>Esc</kbd>.',
					},
				},
				reviewer: {
					welcome: {
						title: 'Willkommen in der Belegprüfung',
						text: 'In wenigen Schritten zeigen wir Ihnen, wie Sie Konten und Buchungen prüfen. Die Einführung zeigt und erklärt nur – sie prüft, beanstandet oder ändert nichts. Beenden können Sie sie jederzeit über das ✕.',
					},
					phase: {
						title: 'Zustand der Belegprüfung',
						text: '<strong>Entwurf</strong>: Die Verwaltung bereitet die Prüfung vor. <strong>Aktiv</strong>: Die Prüfung läuft, Sie können Buchungen prüfen. <strong>Abgeschlossen</strong>: Das Ergebnis steht fest. Ist das Protokoll erstellt, lässt sich nichts mehr ändern.',
					},
					progress: {
						title: 'Fortschritt',
						text: 'Der Balken zeigt, wie viele Buchungen geprüft, beanstandet und noch offen sind. Ein Klick darauf zeigt den Stand je Prüfer.',
					},
					info: {
						title: 'Angaben zur Prüfung',
						text: 'Hier finden Sie Liegenschaft, Buchungsjahr und Frist dieser Belegprüfung.',
					},
					accounts: {
						title: 'Konten',
						text: 'Links stehen alle Konten der Prüfung mit ihrem Fortschritt. Über die Suche finden Sie ein Konto nach Nummer oder Name; die Filter zeigen alle, nur offene oder nur beanstandete Konten.',
					},
					accounts_touch: {
						title: 'Konten',
						text: 'Hier stehen alle Konten der Prüfung mit ihrem Fortschritt. Über die Suche finden Sie ein Konto nach Nummer oder Name; die Filter zeigen alle, nur offene oder nur beanstandete Konten.',
					},
					levels: {
						title: 'Konten → Buchungen → Beleg',
						text: 'Auf diesem Bildschirm sehen Sie immer eine Ebene. Tippen Sie auf ein Konto, um seine Buchungen zu öffnen, und dort auf eine Buchung, um ihren Beleg zu sehen. Der Pfeil <strong>‹</strong> oben links führt jeweils eine Ebene zurück.',
					},
					journals: {
						title: 'Buchungen',
						text: 'Hier stehen die Buchungen des gewählten Kontos. Jede ist <strong>offen</strong>, <strong>geprüft</strong> oder <strong>beanstandet</strong>. Suchen, sortieren und filtern können Sie oben in der Spalte. Die Einführung hat die nächste offene Buchung für Sie ausgewählt.',
					},
					journals_touch: {
						title: 'Buchungen',
						text: 'Hier stehen die Buchungen des gewählten Kontos. Jede ist <strong>offen</strong>, <strong>geprüft</strong> oder <strong>beanstandet</strong>; suchen, sortieren und filtern können Sie oben in der Liste. Die Einführung hat die nächste offene Buchung für Sie ausgewählt. Tippen Sie auf eine Buchung, um ihren Beleg zu öffnen. Der Pfeil <strong>‹</strong> führt zurück zu den Konten.',
					},
					bulk: {
						title: 'Mehrere Buchungen auf einmal',
						text: 'Mit der Mehrfachauswahl markieren Sie mehrere Buchungen und prüfen oder beanstanden sie gemeinsam.',
					},
					receipt: {
						title: 'Der Beleg',
						text: 'Hier sehen Sie den Beleg zur Buchung – aus dem ERP oder als Anlage der Verwaltung. Sie können zoomen, drehen, blättern, herunterladen und drucken. Hat ein Beleg mehrere Blätter, wechseln Sie sie über die Leiste darüber.',
					},
					receipt_touch: {
						title: 'Der Beleg',
						text: 'Hier sehen Sie den Beleg zur Buchung, aus dem ERP oder als Anlage der Verwaltung. Sie können zoomen, drehen, blättern, herunterladen und drucken. Mit <strong>‹</strong> und <strong>›</strong> darüber wechseln Sie zur vorigen oder nächsten Buchung; der Pfeil ganz oben links führt zurück zur Buchungsliste.',
					},
					layout: {
						title: 'Beleg darüber oder daneben',
						text: 'Hier stellen Sie um, ob der Beleg im Detailbereich steht oder als eigene Spalte daneben – praktisch auf großen Bildschirmen. Die Einstellung merkt sich Ihr Browser.',
					},
					verdict: {
						title: 'Prüfen',
						text: '<strong>Geprüft</strong> (<kbd>G</kbd>) bestätigt die Buchung und springt zur nächsten offenen. <strong>Beanstanden</strong> (<kbd>B</kbd>) markiert sie als fehlerhaft – bitte begründen Sie das im Kommentar. <strong>Zurücknehmen</strong> (<kbd>Z</kbd>) macht Ihr Urteil rückgängig. <strong>Nächste offene</strong> (<kbd>N</kbd>) springt ohne Urteil weiter.',
					},
					verdict_readonly: {
						title: 'Urteile der Prüfer',
						text: 'Sie haben hier Lesezugriff oder die Prüfung läuft gerade nicht: Sie sehen den Stand, können aber selbst nicht prüfen. Mit <kbd>N</kbd> und ←/→ blättern Sie trotzdem durch die Buchungen.',
					},
					verdict_touch: {
						title: 'Prüfen',
						text: 'Die Prüfleiste steht immer unten am Bildschirm. <strong>Geprüft</strong> bestätigt die Buchung und springt zur nächsten offenen. <strong>Beanstanden</strong> markiert sie als fehlerhaft; bitte begründen Sie das im Kommentar. <strong>Zurücknehmen</strong> macht Ihr Urteil rückgängig, <strong>Nächste offene</strong> springt ohne Urteil weiter.',
					},
					verdict_readonly_touch: {
						title: 'Urteile der Prüfer',
						text: 'Sie haben hier Lesezugriff oder die Prüfung läuft gerade nicht: Sie sehen den Stand, können aber selbst nicht prüfen. Mit den Knöpfen dieser Leiste blättern Sie trotzdem durch die Buchungen.',
					},
					journal_comments: {
						title: 'Kommentare zur Buchung',
						text: 'Fragen und Begründungen schreiben Sie direkt an die Buchung. Die anderen Prüfer und die Verwaltung sehen sie.',
					},
					review_comments: {
						title: 'Kommentare zur Belegprüfung',
						text: 'Anmerkungen, die keine einzelne Buchung betreffen, gehören hierher. Die Zahl zeigt, wie viele es gibt.',
					},
					documents: {
						title: 'Anlagen',
						text: 'Die Büroklammer öffnet die Unterlagen zur Prüfung, etwa Jahresabrechnung, Kontoauszüge oder Verträge.',
					},
					overall: {
						title: 'Ihr Gesamtergebnis',
						text: 'Sind Sie fertig, geben Sie hier Ihr Gesamtergebnis ab: <strong>Bestätigen</strong> oder <strong>Beanstanden</strong>. Damit schließen Sie Ihre eigene Prüfung ab. Solange die Frist läuft und kein Protokoll erstellt ist, können Sie es zurücknehmen.',
					},
					keys: {
						title: 'Tastenkürzel im Überblick',
						text:
							'<table class="aaremo-tour-keys"><tbody>' +
							'<tr><td><kbd>G</kbd></td><td>Geprüft</td><td><kbd>/</kbd></td><td>Suche</td></tr>' +
							'<tr><td><kbd>B</kbd></td><td>Beanstanden</td><td><kbd>F</kbd></td><td>Fokus-Modus</td></tr>' +
							'<tr><td><kbd>Z</kbd></td><td>Zurücknehmen</td><td><kbd>←</kbd> <kbd>→</kbd></td><td>Blättern</td></tr>' +
							'<tr><td><kbd>N</kbd></td><td>Nächste offene</td><td><kbd>Esc</kbd></td><td>Schließen</td></tr>' +
							'</tbody></table>' +
							'Im Beleg: <kbd>+</kbd> <kbd>−</kbd> zoomen, <kbd>0</kbd> einpassen, <kbd>R</kbd> drehen, <kbd>Bild↑</kbd> <kbd>Bild↓</kbd> blättern.',
					},
					menu: {
						title: 'Das Menü ☰',
						text: 'Hinter ☰ liegen die <strong>Suche</strong>, die <strong>Anlagen</strong> der Prüfung (etwa Jahresabrechnung, Kontoauszüge, Verträge), die <strong>Kommentare zur Belegprüfung</strong>, Ihr <strong>Gesamtergebnis</strong> und diese <strong>Einführung</strong>. Die Zahl am Menü zählt Anlagen und Kommentare. Sind Sie fertig, geben Sie dort Ihr Gesamtergebnis ab: <strong>Bestätigen</strong> oder <strong>Beanstanden</strong>. Solange die Frist läuft und kein Protokoll erstellt ist, können Sie es zurücknehmen.',
					},
					menu_readonly: {
						title: 'Das Menü ☰',
						text: 'Hinter ☰ liegen die <strong>Suche</strong>, die <strong>Anlagen</strong> der Prüfung (etwa Jahresabrechnung, Kontoauszüge, Verträge), die <strong>Kommentare zur Belegprüfung</strong> und diese <strong>Einführung</strong>. Die Zahl am Menü zählt Anlagen und Kommentare.',
					},
					outro: {
						title: 'Viel Erfolg beim Prüfen',
						text: 'Diese Einführung starten Sie jederzeit erneut über das <strong>?</strong> oben in der Belegprüfung.',
					},
					outro_touch: {
						title: 'Viel Erfolg beim Prüfen',
						text: 'Diese Einführung starten Sie jederzeit erneut über ☰ → <strong>Einführung</strong>.',
					},
				},
				manager: {
					welcome: {
						title: 'Belegprüfung verwalten',
						text: 'Wir zeigen Ihnen, wie Sie eine Belegprüfung einstellen, Prüfer festlegen, Anlagen hochladen und Buchungen zuordnen. Die Einführung zeigt nur – sie speichert, aktiviert oder ordnet nichts zu.',
					},
					lifecycle: {
						title: 'Der Ablauf',
						text: 'Eine Belegprüfung beginnt als <strong>Entwurf</strong>: Sie legen Stammdaten und Prüfer fest. Mit <strong>Aktivieren</strong> startet die Prüfung. Nach dem <strong>Abschließen</strong> erstellen Sie das Protokoll – danach ist die Prüfung festgeschrieben: kein Wiederöffnen, keine neue Frist, kein Zurücknehmen mehr.',
					},
					gear: {
						title: 'Einstellungen und Prüfer',
						text: 'Über das Zahnrad erreichen Sie alles, was Sie an dieser Belegprüfung einstellen.',
					},
					menu: {
						title: 'Das Menü ☰',
						text: 'Hinter ☰ liegen die <strong>Suche</strong>, die <strong>Anlagen</strong>, die <strong>Kommentare zur Belegprüfung</strong>, die <strong>Einstellungen</strong> mit Stammdaten, Prüfern und Status sowie diese <strong>Einführung</strong>. Die Zahl am Menü zählt Anlagen und Kommentare.',
					},
					basics: {
						title: 'Stammdaten',
						text: 'Im ersten Reiter pflegen Sie Name, Frist und die übrigen Angaben der Prüfung.',
					},
					basics_touch: {
						title: 'Stammdaten',
						text: 'Über ☰ → <strong>Einstellungen</strong> öffnen Sie diesen Dialog. Im ersten Reiter pflegen Sie Name, Frist und die übrigen Angaben der Prüfung.',
					},
					status: {
						title: 'Status',
						text: 'Daneben steht der Status mit den Schritten Aktivieren, Deaktivieren, Abschließen, Wieder öffnen und Protokoll – jeweils mit einem Satz, was der Schritt bewirkt. Hier schalten Sie auch die Kommentare ein oder aus.',
					},
					status_touch: {
						title: 'Status',
						text: 'Unter den Stammdaten steht der Status mit den Schritten Aktivieren, Deaktivieren, Abschließen, Wieder öffnen und Protokoll, jeweils mit einem Satz, was der Schritt bewirkt. Hier schalten Sie auch die Kommentare ein oder aus.',
					},
					reviewers: {
						title: 'Prüfer festlegen',
						text: 'Im Reiter „Prüfer" wählen Sie Personen über Suche und Häkchen aus und legen fest, ob sie <strong>lesend</strong> (einsehen und kommentieren) oder <strong>schreibend</strong> (prüfen und Ergebnis abgeben) teilnehmen. Prüfer lassen sich nur ändern, solange die Prüfung ein Entwurf ist.',
					},
					save: {
						title: 'Speichern',
						text: '„Speichern" übernimmt Ihre Änderungen und lässt den Dialog offen, „Speichern & schließen" schließt ihn danach. Die Einführung schließt den Dialog gleich wieder, ohne zu speichern.',
					},
					documents_open: {
						title: 'Anlagen',
						text: 'Die Büroklammer öffnet die Anlagen der Belegprüfung. Prüfer sehen sie nur, Sie können sie pflegen.',
					},
					documents_upload: {
						title: 'Dokumente hochladen',
						text: 'Ziehen Sie Dateien hierher oder wählen Sie sie aus. Jedes Dokument bekommt eine Dokumentenart und eine Bezeichnung.',
					},
					documents_upload_touch: {
						title: 'Dokumente hochladen',
						text: 'Die Anlagen öffnen Sie über ☰ → <strong>Anlagen</strong>. Tippen Sie hier, um Dateien auszuwählen. Am Computer können Sie sie auch hierher ziehen. Jedes Dokument bekommt eine Dokumentenart und eine Bezeichnung.',
					},
					documents_split: {
						title: 'Ein Dokument oder mehrere',
						text: 'Mehrere Dateien werden normalerweise zu einem Dokument. Mit diesem Schalter wird jede Datei ein eigenes Dokument – praktisch, wenn Sie viele einzelne Belege hochladen.',
					},
					documents_assign: {
						title: 'Buchungen zuordnen',
						text: 'Hier sehen Sie, welchen Buchungen das gewählte Dokument zugeordnet ist. Über <strong>+</strong> wählen Sie Konto und Buchung und ordnen es zu – danach steht es bei dieser Buchung als Beleg. Eine Buchung trägt höchstens einen Beleg.',
					},
					documents_assign_touch: {
						title: 'Buchungen zuordnen',
						text: 'Hier sehen Sie, welchen Buchungen das gewählte Dokument zugeordnet ist. Über <strong>+</strong> wählen Sie Konto und Buchung und ordnen es zu. Danach steht es bei dieser Buchung als Beleg. Eine Buchung trägt höchstens einen Beleg. Der Pfeil oben links führt zurück zur Liste der Dokumente.',
					},
					receipt_assign: {
						title: 'Beleg direkt an der Buchung',
						text: 'Fehlt einer Buchung der Beleg, ordnen Sie ihr hier eine vorhandene Anlage zu oder laden eine neue hoch – die Buchung ist dabei schon vorgemerkt.',
					},
					reviewer_panel: {
						title: 'Stand der Prüfer',
						text: 'Hier sehen Sie je Prüfer den Fortschritt und das abgegebene Gesamtergebnis. Solange nichts festgeschrieben ist, können Sie ein Gesamtergebnis zurücknehmen.',
					},
					outro: {
						title: 'Alles eingerichtet',
						text: 'Diese Einführung starten Sie jederzeit erneut über das <strong>?</strong> oben. Ihre Prüfer bekommen beim ersten Öffnen eine eigene Einführung.',
					},
					outro_touch: {
						title: 'Alles eingerichtet',
						text: 'Diese Einführung starten Sie jederzeit erneut über ☰ → <strong>Einführung</strong>. Ihre Prüfer bekommen beim ersten Öffnen eine eigene Einführung.',
					},
				},
			},
			focus: {
				open: 'Fokus',
				open_hint: 'Prüfansicht ohne Kopf- und Navigationsbereich',
				close: 'Fokus verlassen',
				subline: 'Belegprüfung · Buchungsjahr {year}',
				receipt_position: 'Beleg {position} von {total}',
				consensus: '{approved} geprüft · {denied} beanstandet',
				account_position: '{account} · Buchung {position} von {total}',
				reviews: 'Prüfungen · {done} von {total}',
				approve: 'Geprüft — weiter',
				deny: 'Beanstanden',
				deny_hint: 'Eine Beanstandung sollten Sie im Kommentar begründen.',
				comments: 'Kommentare · {count}',
				comments_hint: 'Kommentieren in der Belegprüfung',
				queue: 'Warteschlange',
				comments_empty: 'Noch keine Kommentare zu dieser Buchung.',
				comments_reply: 'Antworten',
				comments_reply_to: 'Antwort an {name}',
				position: 'Buchung {position} von {total}',
				switch_account: 'Konto wechseln',
				no_receipt: 'Zu dieser Buchung ist kein Beleg hinterlegt.',
				field: {
					date: 'Buchungsdatum',
					primanota: 'Primanota',
					contra_account: 'Gegenkonto',
					debit: 'Soll',
					credit: 'Haben',
				},
				keys: {
					approve: 'Geprüft',
					deny: 'Beanstanden',
					next: 'Nächste offene',
					withdraw: 'Zurücknehmen',
					step: 'Blättern',
					exit: 'Verlassen',
				},
			},
			receiptAssign: {
				title: 'Anlage zuordnen',
				available:
					'{count} Dokument der Prüfung | {count} Dokumente der Prüfung',
				upload: 'Neu hochladen',
				search: 'Anlage suchen (Bezeichnung, Dateiname) …',
				none: 'Diese Belegprüfung hat noch keine Anlagen. Laden Sie zuerst ein Dokument hoch.',
				noMatch: 'Keine Anlage passt zu Ihrer Suche.',
				unnamed: 'Unbenanntes Dokument',
				fileCount: '{count} Datei | {count} Dateien',
				unassigned: 'noch keiner Buchung zugeordnet',
				replaces: 'Zuordnung würde ersetzt',
				hint: 'Wird sofort gespeichert und ist für alle Prüfer sichtbar.',
				submit: 'Zuordnen',
				assigned: 'Die Anlage wurde der Buchung zugeordnet.',
			},
			receipt: {
				title: 'Buchung',
				no_journal: 'Wählen Sie eine Buchung aus.',
				download: 'Beleg herunterladen',
				none: 'Zu dieser Buchung liegt kein Beleg vor.',
				window: 'Beleg',
				label: 'Beleg',
				layout: {
					split: 'Beleg in eigene Spalte legen',
					stack: 'Beleg zurück in die Detailspalte',
				},
				fileCount: '{count} Datei | {count} Dateien',
				origin: {
					erp: 'ERP',
					attachment: 'Anlage',
					none: 'kein Beleg',
				},
				type: {
					pdf: 'PDF',
					image: 'Bild',
					file: 'Datei',
					none: 'Kein Beleg',
				},
				viewer: {
					loading: 'Beleg wird geladen …',
					load_error: 'Der Beleg konnte nicht geladen werden.',
					zoom_in: 'Vergrößern (+ oder Strg+Mausrad)',
					zoom_out: 'Verkleinern (− oder Strg+Mausrad)',
					rotate: 'Drehen (R)',
					fullscreen: 'Vollbild',
					fullscreen_exit: 'Vollbild beenden (Esc)',
					download: 'Herunterladen',
					print: 'Drucken',
					prev_page: 'Vorherige Seite (←)',
					next_page: 'Nächste Seite (→)',
				},
			},
			journal_reviews: {
				progress: '{done} von {total} geprüft',
				disputed: '{count} beanstandet',
				empty:
					'Für diese Belegprüfung sind noch keine Prüfer mit Schreibzugriff festgelegt.',
			},
			comments: {
				placeholder: 'Kommentar zur Buchung …',
				readonly:
					'Die Belegprüfung ist abgeschlossen — Kommentare sind nur noch lesbar.',
				readonly_no_permission: 'Kommentare sind für Sie nur lesbar.',
				title: 'Kommentare',
				open_review: 'Kommentare zur Belegprüfung',
				open_account: 'Kommentare zum Konto',
				total: '{count} Kommentar | {count} Kommentare',
				empty: 'Noch keine Kommentare.',
				reply: 'Antworten',
				reply_to: 'Antwort an {name}',
				placeholder_review: 'Kommentar zur Belegprüfung …',
				placeholder_account: 'Kommentar zum Konto …',
				disabled:
					'Kommentare sind für diese Belegprüfung ausgeschaltet — vorhandene bleiben lesbar.',
				no_permission: 'Sie können an dieser Belegprüfung nicht kommentieren.',
				internal: 'Intern',
				internal_hint: 'Nur für die Hausverwaltung sichtbar',
			},
			confirm: {
				step: 'Frage {current} von {total}',
			},
			protocol: {
				not_generated: 'Das Protokoll wurde noch nicht erzeugt.',
			},
			reviewer_dialog: {
				persons: 'Personen der Liegenschaft',
				no_match: 'Keine Person entspricht Ihrer Suche.',
				only_with_account: 'Nur Personen mit Benutzerkonto können prüfen.',
				access_per_person: 'Zugriff je Person',
				access_hint:
					'Lesend = einsehen und kommentieren · Schreibend = prüfen und Ergebnis abgeben.',
				selected: '{count} Prüfer ausgewählt',
			},
			documents: {
				hint: 'Anlagen der Prüfung — die Belege der Buchungen kommen aus dem ERP und sind hier nicht änderbar.',
				locked:
					'Abgeschlossen — die Anlagen sind schreibgeschützt und nur noch einsehbar.',
				readonly:
					'Nur einsehbar — die Anlagen der Belegprüfung pflegt die Verwaltung.',
				empty: 'Es sind noch keine Anlagen hinterlegt.',
				open: 'Anlagen der Belegprüfung',
				manage: 'Anlagen pflegen',
				download_file: 'Datei herunterladen',
				no_preview:
					'Für diesen Dateityp gibt es keine Vorschau — laden Sie die Datei herunter.',
				rules:
					'Eine Buchung trägt höchstens einen Beleg. ERP-Belege werden nicht ersetzt. Löschen wird erst mit „Speichern" wirksam.',
				assign: {
					title: 'Buchung',
					account: 'Konto der Belegprüfung',
					journal: 'Buchung',
					without_receipt: 'Nur ohne Beleg',
					choose_account: 'Wählen Sie zuerst ein Konto.',
					attach: 'Zuordnen',
					attach_dated: 'Buchung {date} zuordnen',
					prepare: 'Vormerken',
					prepare_dated: 'Buchung {date} vormerken',
					prepared: 'Vorgemerkt — die Buchung wird mit „Speichern" zugeordnet.',
					pending: 'wird zugeordnet',
					remove_pending: 'Vormerkung entfernen',
					needs_file:
						'Legen Sie zuerst eine Datei ab — danach lässt sich die Buchung vormerken und wird mit „Speichern" zugeordnet.',
					detach: 'Zuordnung lösen',
					add: 'Weitere Buchung zuordnen',
					add_close: 'Auswahl schließen',
					assigned: 'Zugeordnete Buchungen',
					after_save:
						'Buchungen lassen sich zuordnen, sobald das Dokument gespeichert ist.',
					accounts_group: 'Sachkonten',
					journals_group_without: 'Ohne Beleg',
					journals_group_all: 'Buchungen',
					origin_attachment: 'Anlage',
					origin_erp: 'ERP',
					origin_none: 'kein Beleg',
					none: 'Dieser Beleg ist noch keiner Buchung zugeordnet.',
					overwrite:
						'Dieser Buchung ist bereits ein anderer Beleg zugeordnet. Beim Zuordnen wird die bisherige Zuordnung ersetzt.',
					attached: 'Die Buchung wurde dem Beleg zugeordnet.',
					detached: 'Die Zuordnung wurde gelöst.',
				},
			},
			edit: {
				title: 'Belegprüfung bearbeiten',
				deadline_hint:
					'Eine geänderte Frist hebt einen bestehenden Abschluss wieder auf.',
				reminder_requires_deadline:
					'Die Erinnerung lässt sich erst wählen, wenn eine Frist gesetzt ist.',
				team_locked:
					'Der Ansprechpartner lässt sich nicht mehr ändern, sobald ein Protokoll erzeugt wurde.',
			},
		},
	},
}
